import { useCallback } from "react";
import SetSelector from "components/Inputs/SetSelector";
import { useChartSetSelectContext } from "components/charting/contexts/ChartSetSelectContext";
import { useChartSetSelectStatusContext } from "components/charting/contexts/ChartSetSelectStatusContext";
import type { MeasurementSet } from "types";

export interface AthleteProfileChartSetSelectorProps {}

function AthleteProfileChartSetSelector(props: AthleteProfileChartSetSelectorProps) {
  const { value, options, onChange } = useChartSetSelectContext();
  const status = useChartSetSelectStatusContext();

  const handleChange = useCallback((_: unknown, sets: MeasurementSet[]) => onChange(sets), [onChange]);

  return <SetSelector value={value} options={options} onChange={handleChange} status={status} />;
}

export default AthleteProfileChartSetSelector;
